import { IcsCalendar, IcsEvent } from 'ts-ics'
import { v4 } from 'uuid'

import { getProfileTimezone } from '@/shared/composables/timezone'
import { getScheduleEventDisplayName } from '@/shared/utils/schedule'

import { buildIcsTimezone } from './ics-date'
import { omitIcsSequence, prepareEventForIcsExport, PrepareIcsExportOptions, ScheduleOrganizerIdentity } from './lib'

export { getScheduleEventDisplayName }

const V_CALENDAR_PROD_ID = 'rtu-web-client'
const V_CALENDAR_VERSION = '2.0'
const V_CALENDAR_METHOD = 'REQUEST'

export const DEFAULT_V_CALENDAR: IcsCalendar = {
  prodId: V_CALENDAR_PROD_ID,
  version: V_CALENDAR_VERSION,
  method: V_CALENDAR_METHOD,
  events: [],
}

export const getDefaultCalendar = (
  event: IcsEvent,
  options?: PrepareIcsExportOptions & { identity?: ScheduleOrganizerIdentity },
): IcsCalendar => {
  const timezone = getProfileTimezone()
  const preparedEvent = prepareEventForIcsExport(event, options?.identity, options)

  return {
    ...DEFAULT_V_CALENDAR,
    timezones: [buildIcsTimezone(timezone, preparedEvent.start.date)],
    nonStandard: {
      wrTimezone: timezone,
    },
    events: [options?.includeSequence ? preparedEvent : omitIcsSequence(preparedEvent)],
  }
}

export const getDefaultEvent = (date: Date = new Date(), summary = '', uid?: string): IcsEvent => ({
  stamp: {
    date: new Date(),
  },
  summary,
  start: {
    date,
  },
  duration: {
    hours: 1,
  },
  uid: uid ? uid : v4(),
})
